import styled from 'styled-components';

export const DivHistory = styled('div')`
  &&& {
    background: ${({ theme }) => theme.white};
    padding: 0.3rem 1rem;
    margin: 0;
    line-height: 1.3rem;
  }
`;

export const InformationType = styled.div`
  &&& {
    display: flex;
    flex-direction: row;
    color: #000 !important;
    margin: 0;
    padding: 0 0.1rem;

    > span {
      font-weight: bold;
      padding-right: 5px;
    }
  }
`;

